import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import searchSelectValueStyles from './styles';

const SearchSelectValue = ({
  text, amount, showChip,
}) => {
  const classes = searchSelectValueStyles();

  return (
    <Box
      display="flex"
      alignItems="center"
    >
      {text}
      {' '}
      {amount > 0 && (
        showChip ? <Chip label={amount} className={classes.chipActive} /> : amount
      )}
    </Box>
  );
};

SearchSelectValue.defaultProps = {
  showChip: true,
};

SearchSelectValue.propTypes = {
  text: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  showChip: PropTypes.bool,
};

export default SearchSelectValue;
